const doc = [({"da":({"js":({"admin":({"tenants":({"create_card":({"the_tenant_was_created":"Tenanten blev oprettet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;